import React from 'react';

import { Colors } from "../../theme";
import { textStyles } from "../../theme/fonts-ppv";

const sizeOptions = {
    md: {
        width: 20,
        height: 20,
    },
    lg: {
        width: 24,
        height: 24,
    }
}

const colorOptions = {
    default: Colors.grey600,
    warning: Colors.yellow600,
    success: Colors.green600,
    error: Colors.red600,
}

const TagCount = ({ 
    id,
    count,
    size = 'md',
    backgroundColor = 'default',
    maximum,
}: { 
    id: string;
    count: number;
    size?: keyof typeof sizeOptions;
    backgroundColor?: keyof typeof colorOptions;
    maximum?: number;
}) => {
    const { width, height } = sizeOptions[size];
    return (
        <div
            id={id}
            data-testid={id}
            style={{
                ...textStyles.subtitle3,
                backgroundColor: colorOptions[backgroundColor],
                minWidth: width,
                height: height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: Colors.white,
                borderRadius: '24px',
                padding: '4px'
            }}
        >
            {count}
            {!!maximum && <span>/{maximum}</span>}
        </div>
    );
};

export default TagCount;